import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const forWho = ['Profesionales de 23 a 35 años con un trabajo e ingreso estable.', 'Personas que sienten que "ganan bien" pero su patrimonio no crece.', 'Quienes quieren empezar a invertir pero tienen miedo a perder su capital.', 'Alguien que busca estabilidad y paz mental, no promesas mágicas de riqueza.'];
const notForWho = ['Personas que buscan esquemas de "hacerse rico rápidamente".', 'Gente con crisis de deuda extrema que necesita asesoría legal.', 'Inversionistas expertos que buscan estrategias especulativas de alto riesgo.'];
export function WhoIsFor() {
  return <AnimatedSection className="py-24 bg-navy-900 relative px-4 sm:px-6 lg:px-8" data-id="element-163">
      <div className="max-w-6xl mx-auto" data-id="element-164">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-165">
          {/* For Who */}
          <div className="bg-navy-800 border border-navy-700 rounded-3xl p-8 sm:p-10" data-id="element-166">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-167">
              <span className="w-8 h-8 rounded-full bg-green-500/10 flex items-center justify-center" data-id="element-168">
                <CheckCircle className="w-5 h-5 text-green-400" data-id="element-169" />
              </span>
              Para quién ES
            </h3>
            <ul className="space-y-6" data-id="element-170">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-171">
                  <CheckCircle className="w-6 h-6 text-green-400 shrink-0 mt-0.5" data-id="element-172" />
                  <span className="text-slate-300 text-lg" data-id="element-173">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For Who */}
          <div className="bg-navy-900 border border-navy-800 rounded-3xl p-8 sm:p-10 relative overflow-hidden" data-id="element-174">
            <div className="absolute inset-0 bg-red-500/5 mix-blend-overlay" data-id="element-175" />
            <h3 className="text-2xl font-bold text-slate-400 mb-8 flex items-center gap-3 relative z-10" data-id="element-176">
              <span className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-177">
                <XCircle className="w-5 h-5 text-red-400" data-id="element-178" />
              </span>
              Para quién NO ES
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-179">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-180">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-181" />
                  <span className="text-slate-400 text-lg" data-id="element-182">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-183" />
    </AnimatedSection>;
}